<template>
  <div
    class="home-container"
    :style="{ height: $hideHeader != 1 ? '88.59vh' : '100vh' }"
  >
    <dv-loading v-if="loading">Loading...</dv-loading>
    <template v-else>
      <div class="map-container">
        <MapView @initMap="initMap"></MapView>
      </div>
      <div class="right-container">
        <scrollBoard></scrollBoard>
        <chartBlock style="margin-top: 1%"></chartBlock>
      </div>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import MapView from "@/views/MapView";
// import tableBlock from "@/components/tableBlock";
import chartBlock from "@/components/chartBlock";
import scrollBoard from "@/components/scrollBoard";
import { mapState } from "vuex";

export default {
  name: "home",
  data() {
    return {
      map: null
    };
  },
  components: {
    MapView,
    chartBlock,
    scrollBoard
  },
  computed: {
    ...mapState(["loading", "data_time", "authUserInfo"])
  },
  mounted() {},
  methods: {
    initMap(map) {
      this.map = map;
    }
  },
  watch: {
    data_time() {
      if (this.data_time === "0") return;
      this.$store.dispatch("getStationData");
    }
  }
};
</script>

<style lang="less">
.home-container {
  width: 100%;
  // padding: 0 50px;
}

.map-container {
  height: 100%;
  width: 64%;
  display: inline-block;
  vertical-align: top;
  position: relative;
}

.right-container {
  margin-left: 0.5%;
  height: 100%;
  width: 34%;
  display: inline-block;
  vertical-align: top;
}
</style>
